import React, { useEffect, useState } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "./_redux/Actions";
import { FieldFeedbackLabel } from "../../../_metronic/_partials/controls/forms/FieldFeedbackLabel";
// import { Select } from "../../../_metronic/_partials/controls";
import { Select2 } from "select2-react-component";
import { useFormikContext } from "formik";

const getFieldCSSClasses = (touched, errors) => {
    const classes = [];
    if (touched && errors) {
        classes.push("is-invalid-select");
    }

    if (touched && !errors) {
        classes.push("is-valid-select");
    }
    return classes.join(" ");
};

const SearchSelectInput = ({
    field, // { name, value, onChange, onBlur }
    form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
    label,
    withFeedbackLabel = true,
    customFeedbackLabel,
    children,
    filter,
    ...props
}) => {

    const [options, setOptions] = useState([]);
    const [fvalue, setFvalue] = useState(undefined);
    const [count, setCount] = useState(0);
    const [fdata, setFdata] = useState(filter);
    const [source, setSource] = useState(props.source);
    const dispatch = useDispatch();

    const { setFieldValue } = useFormikContext();
    useEffect(() => {        
        setFvalue(undefined);
        setFieldValue('');
        dispatch(actions.getSearchList({ source: props.source, filter: filter }));
    }, [fdata, source, props.count]);


    const { currentState } = useSelector(
        (state) => ({ currentState: state.searchList }),
        shallowEqual
    );
    const { searchData } = currentState

    useEffect(() => {
        let data = searchData[props.source];
        if (searchData && searchData[props.source]) {
            data = searchData[props.source].map((item) => { return { value: item._id, label: item.name || item.title || item.companyName } })

            if(props.isShowAll) {
                data.unshift( {value : 'all', label : 'All'})
            }
            setOptions(data);
            // setFvalue(field.value);
            setCount(count + 1);
        }
    }, [searchData]);

    useEffect(() => {
        setFvalue(field.value);
    }, [field && field.value]);

    const UpdateValue = (value) => {
        setFieldValue(field.name, value);
        setFvalue(value);
        if (props.onSelect) {
            const item = searchData[props.source].find(item => item._id === value);
            props.onSelect(item);
        }
    }
    
    return (
        <>
            <div className={getFieldCSSClasses(touched[field.name], errors[field.name])}>
                {label && <label className={props.isRequired ? 'required' : '' }>Select {label}</label>}
                <Select2
                    className={getFieldCSSClasses(touched[field.name], errors[field.name])}
                    data={options}
                    {...field}
                    {...props}
                    value={fvalue}
                    isClearable={true}
                    update={value => UpdateValue(value)}
                >
                </Select2>
                {/* <Select
                onChange={(e) => onChangeHandle(e.target.value)}
                className={getFieldCSSClasses(touched[field.name], errors[field.name])}
                // options={options}
                // onSelect={onChangeHandle}
                {...field}
                {...props}
            >
                <option value="">&nbsp;</option>
                {
                    searchData && searchData[props.source] && searchData[props.source].map(item => <option key={item._id} value={item._id}>{item.name || item.title}</option>)
                }
            </Select> */}
                {withFeedbackLabel && (
                    <FieldFeedbackLabel
                        error={errors[field.name]}
                        touched={touched[field.name]}
                        label={label}
                        customFeedbackLabel={customFeedbackLabel}
                    />
                )}
            </div>
        </>
    );
}
export default SearchSelectInput;